// Vue plugin <eui-panelyta>:

import Vue from 'vue';
import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import throttla from 'lodash.throttle';
import euiPositioneradPanelcontainer from 'v-components/euiPositioneradPanelcontainer';
//import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';

//import { TimelineLite, TweenLite, Power1 } from 'gsap/TweenMax';
import { TweenLite, Power1 } from 'gsap/TweenMax';
//import { TweenLite, Elastic } from 'gsap/TweenMax';

// Klon av originalet på https://github.com/Kelin2025/vue-responsive-components:
import { ResponsiveContainerMixin } from 'ResponsiveContainer';
import { coordinatesIntersectWithRect, coordinatesIntersectWithRect_LeftHalf, coordinatesIntersectWithRect_RightHalf } from 'CoordinatesIntersectWithRect';

import axios from 'axios';
import objectToFormData from 'object-to-formdata';
import { Resultat } from 'classes/ResultatClasses';

//import { Draggable } from 'gsap/all';

//import euiMaintainDisabled from 'v-directives/euiMaintainDisabled';

import chartwidget from 'v-components/widgets/ssoChartWidget.vue';
import kontoutdragwidget from 'v-components/widgets/ssoKontoutdragWidget.vue';
import kundreskontrawidget from 'v-components/widgets/ssoKundreskontraWidget.vue';
import leverantorsreskontrawidget from 'v-components/widgets/ssoLeverantorsreskontraWidget.vue';
import kundreskontraminiwidget from 'v-components/widgets/ssoKundreskontraMiniWidget.vue';
import leverantorsreskontraminiwidget from 'v-components/widgets/ssoLeverantorsreskontraMiniWidget.vue';
//import youtubewidget from 'v-components/widgets/euiYoutubeWidget.vue';
import unknownwidget from 'v-components/widgets/ssoUnknownWidget.vue';

import laggTillKopieraFlyttaEllerKlonaWidget from 'ssoLaggTillKopieraFlyttaEllerKlonaWidget';


// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


// ###################################################################################################

export default {

	name: 'eui-panelyta',

	// Ang '-rullningsbar-overlay-persist -padding-right-for-overflow-overlay' nedan, se kommentarer i v-euiPanelyta.css.cshtml:
	template: `
		<div class="_eui-panelyta -rullningsbar-overlay-persist -padding-right-for-overflow-overlay"
			:class="{ '-inaktiverad':skaVaraInaktiverad, '-osynlig':skaVaraOsynlig }"
			:disabled="vpInaktiverad"
			:style="{
				margin: '-' + vpGap / 2 + 'px'
				, width: 'calc(100% + ' + vpGap + 'px)'
				, height: 'calc(100% + ' + vpGap + 'px)'
				, 'min-height': 'calc(100% + ' + vpGap + 'px)'
			}"
		>
			<eui-positionerad-panelcontainer v-for="(item, index) in vpItems" :key="item.widgetId"
				:vp-grid="vpGrid"
				:vp-gap="vpGap"

				:vp-index="index"

				:vp-order="item.order"
				:vp-width="item.widthInGridUnits"
				:vp-height="item.heightInGridUnits"

				:vp-min-width="item.minWidthInGridUnits"
				:vp-min-height="item.minHeightInGridUnits"

				:vp-max-width="item.maxWidthInGridUnits"
				:vp-max-height="item.maxHeightInGridUnits"

				:vp-prevent-resizing="item.preventResizing"

				:vp-drag-and-drop-aktiverad="vpArIRedigeralage"

				:vp-panelytans-dimensioner-och-positioner="panelytansDimensionerOchPositioner"
			>
				<!--	:vp-meny-config.sync="euiPopUpMenyClasses.castFrom(item.menyConfig)"-->
				<component :is="item.elementName"
					:vp-widget-id="item.widgetId"
					:vp-widget-element-name="item.elementName"
					:vp-widget-original-element-name="item.originalElementName"
					:vp-widget-parameters="item.parameters"
					:vp-widget-month="item.month"
					:vp-widget-settings.sync="item.settings"
					:vp-widget-data="item.data"

					:vp-ar-i-redigeralage="vpArIRedigeralage"

					:vp-meny-config.sync="item.menyConfig"

					@menyalternativ-valt-i-widget="onMenyalternativValtIWidget"

				></component>
			</eui-positionerad-panelcontainer>
		</div>
	`,


	//-------------------------------------------------------------------------------------------------------------------------------------

	// Lokalt registrerade komponenter
	components: {
		[euiPositioneradPanelcontainer.name]: euiPositioneradPanelcontainer,

		chartwidget,
		kontoutdragwidget,
		kundreskontrawidget,
		leverantorsreskontrawidget,
		kundreskontraminiwidget,
		leverantorsreskontraminiwidget,
		//youtubewidget,
		unknownwidget,
	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	mixins: [
		euiLifecycleStatusesMixin,
		ResponsiveContainerMixin
	],

	// Det måste finnas minst en breakpoint för att vueResponsiveComponentsMixin ska skrida till verket och sätta w/h under data:
	breakpoints: { dummy() { return true }, },


	//-------------------------------------------------------------------------------------------------------------------------------------

	props: {
		vpItems: {
			type: Array,
			required: true
		},

		vpGrid: {
			type: Object,
			default() { return { x: 90, y: 60 }; },		// y som 2/3 av x blir nog lagom.
		},
		vpGap: {
			type: Number,
			default: 16,
		},

		vpArIRedigeralage: {
			type: Boolean,
			default: false,
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	data() {
		return {
			uniktId: 'eui-panelyta-unikt-' + (++uniktIdCounter),
			edgeOverlappingSize: 20,		// px. Konstant utan hänsyn till gap. Gappet (halva) adderas vid användning av denna.
			tidigareItemsDimOchPos: [],					// ..under pågående dragging.
			//senasteMottagnaMuskoordinater: { x: 0, y: 0 },	// ..under pågående dragging.
			timerForRepetitionAvInscrollning: null,					// ..under pågående dragging. null = timern kör inte.

			//// Se https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle.
			//// Obs! Query for values using only *longhand* names like font-size.  Querying with *shorthand* names like font will not work with the majority of browsers.
			//// Obs! The returned style is a *live* object (CSSStyleDeclaration), which updates itself automatically when the element's style is changed. Detta har dock *ingenting* med Vues reaktivitet att skaffa (man kan ex.vis inte watcha förändringar).
			//// Denna används i de flesta fall (alltid?) som källa då värden under offset, client och scroll nedan ska sättas:
			//computedStyle: {},


			// Aktuella dimensioner och positioner för panelytan. Uppdateras vid förändringar:
			//
			// 'offset' = "outer", oberoende av ev border och rulln.list (förutsätter ev box-sizing:border-box; som vi kör med som default). Left/top är relativt parent/container:s dito.
			//
			// 'client' = "inner", med ev border och rulln.list (om den inte är overflow) borträknade. Dock ingår ev padding. Left/top är relativt 'offset'.
			//
			// 'scroll' = width/height som client ("inner"), men för hela den bakomliggande rullbara bredden/höjden. Left/top är aktuell scrollposition.
			//
			// 'vue-responsive-components', nedan 'el' (endast width/height) = som client ("inner"), men med även padding borträknad = disponibel yta (innersta rutan i Chrome DevTools Computed-flik).
			//
			// Ev transform på panelytan påverkar *inga* av dessa värden.
			//
			// Exempel, med:
			// - Margin 20 som påverkar offsetLeft/-Top.
			// - Padding 38,9 på den *ovanliggande* containern (parent) som påverkar offsetLeft/-Top.
			// - Border 10 som påverkar clientLeft/-Top/-Width/-Height och scrollWidth/-Height.
			// - PaddingRight som endast påverkar elWidth.
			//
			// "offset: x:58, y:29, 1290 x 560    client: x:10, y:10, 1253 x 540    scroll: x:0, y:0, 1253 x 600   el: 1103 x 540"

			// Underobjekt för att enklare kunna skickas med till varje <eui-positionerad-panelcontainer>:
			panelytansDimensionerOchPositioner: {

				// Vissa av nedanstående kan vara *med* decimaler:
				// Eller? (Får se var jag landar i slutimplementationen.)
				offset: { left: 0, top: 0, width: 0, height: 0 },		// px
				client: { left: 0, top: 0, width: 0, height: 0 },		// px
				scroll: { left: 0, top: 0, width: 0, height: 0 },		// px
				// el: Använd ist. this.el: { } som injekteras av vueResponsiveComponentsMixin.
			},

			tween: {
				antalNodes: null,
				nodes: null,
				//dirty: null,
				duration: null,
				omega: null,
				zeta: null,
				tweenInfos: null,
				//timeline: null,
			},

			// Även el:{ } från mixinen ovan!
		};
	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	computed: {

		// Denna är "reaktiv" i och med att alla ingående variabler är reaktiva:
		ytansBredd() {
			// Obs! Här används el.* ist.f. $el.clientWidth, för att den, tack vara vueResponsiveComponentsMixin, övervakas och triggar ändringar av denna computed som kan användas i en watch:
			//return this.$el.clientWidth;	// 'offsetX' = "outer", medan 'clientX' = inner med border och ev rulln.list borträknad.
			return Math.trunc(this.el.width);	// Heltal! Not (!) Math.round();
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		// Denna är "reaktiv" i och med att alla ingående variabler är reaktiva:
		ytansHojd() {
			// Obs! Här används el.* ist.f. $el.clientWidth, för att den, tack vara vueResponsiveComponentsMixin, övervakas och triggar ändringar av denna computed som kan användas i en watch:
			return Math.trunc(this.el.height);	// Heltal! Not (!) Math.round();
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		//// Denna är "reaktiv" i och med att alla ingående variabler är reaktiva:
		//ytansDimensions() {
		//	return (this.ytansBredd + ' x ' + this.ytansHojd);
		//},


		//-------------------------------------------------------------------------------------------------------------------------------------

		isScrolledToTop() {
			return this.panelytansDimensionerOchPositioner.scroll.top === 0;
		},

		isScrolledToBottom() {
			return this.panelytansDimensionerOchPositioner.scroll.top ===
				(this.panelytansDimensionerOchPositioner.scroll.height - this.panelytansDimensionerOchPositioner.client.height);
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);	// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	watch: {

		ytansBredd(nyttVarde, tidigareVarde) {
			//console.log('Ny bredd på panelytan: ' + tidigareVarde + ' -> ' + nyttVarde);

			if (tidigareVarde !== 0)
			{
				// Bara om det inte är den initiala initieringssättningen:

				// Vet inte om denna behövs när det är browsern själv som flödar om items. Provar utan:
				//// Schedule the function to run at the start of the frame:
				//window.requestAnimationFrame(function () {

				// Sätt de (ev) uppdaterade dim och pos-värdena:
				this.registreraPanelytansDimensionerOchPositioner();

				// Layouta om, med Tween-animering vid behov:
				// Denna registrerar också: registreraPanelytansDimensionerOchPositioner:
				this.tweenanimeraPositionerEfterFlyttning();
			}
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		ytansHojd(nyttVarde, tidigareVarde) {
			//console.log('Ny höjd på panelytan: ' + tidigareVarde + ' -> ' + nyttVarde);

			if (tidigareVarde !== 0)
			{
				// Bara om det inte är den initiala initieringssättningen:

				// Vet inte om denna behövs när det är browsern själv som flödar om items. Provar utan:
				//// Schedule the function to run at the start of the frame:
				//window.requestAnimationFrame(function () {

				// Sätt de (ev) uppdaterade dim och pos-värdena:
				this.registreraPanelytansDimensionerOchPositioner();

				// Denna kan aldrig resultera i en omflödning av layouten.
				// Följdaktligen behöver vi inte heller "layouta om, med Tween-animering", utan endast registrera ändringarna enl ovan.
			}
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		//ytansDimensions(nyttVarde, tidigareVarde) {
		////console.log('Ny dim på panelytan: ' + tidigareVarde + ' -> ' + nyttVarde);

		//// Exempel på "deep watcher":
		//dataproppen: {
		//	handler(nyttVarde, tidigareVarde) {
		//	},
		//	deep: true
		//},
		//},
	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	methods: {

		skapaArrayMedItemsDimOchPos() {

			// Alt metod till Array.from() nedan:
			//let widgetDimensionsAndOrder = [];
			//let i;
			//for (i = 0; i < this.vpItems.length; i++)
			//{
			//	widgetDimensionsAndOrder.push({
			//		widgetId: this.vpItems[i].vpWidgetId,
			//		order: this.vpItems[i].order,
			//		widthInGridUnits: this.vpItems[i].widthInGridUnits,
			//		heightInGridUnits: this.vpItems[i].heightInGridUnits,
			//	});
			//}

			// Array.from kräver polyfill i IE11, vilket sköts via babel-grej i webpack.common.js.
			return Array.from(
				this.vpItems,
				(x) => {
					// Obs! Denna måste stämma med C#:s WidgetController.WidgetDimensionsAndOrder för att kunna användas vid POST:
					return {
						widgetId: x.widgetId,
						order: x.order,
						widthInGridUnits: x.widthInGridUnits,
						heightInGridUnits: x.heightInGridUnits
					};
				}
			);
		},

		//-------------------------------------------------------------------------------------------------------------------------------------

		onMenyalternativValtIWidget({ eventId, eventData }) {

			switch (eventId)
			{
				case 'addThisWidget':
					{
						// eventData = {
						//		fromWidgetId,
						//		toPageId
						// }

						laggTillKopieraFlyttaEllerKlonaWidget(this.$root, this, eventData.fromWidgetId, eventData.toPageId, { typLaggTillKopieraFlyttaEllerKlona: 'lägg till' });
						break;
					}

				case 'klonaWidget':
					{
						const widgetId = eventData;	// Enkom för tydlighet.

						// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
						const item = this.vpItems.filter((item) => { return item.widgetId === widgetId; })[0] || null;

						laggTillKopieraFlyttaEllerKlonaWidget(this.$root, this, widgetId, this.$root.selectedDashboardPage, {
							typLaggTillKopieraFlyttaEllerKlona: 'klona',
							order: item.order + 1
						});
						break;
					}

				case 'kopieraWidgetTillSida':
					{
						// eventData = {
						//		fromWidgetId,
						//		toPageId
						// }

						laggTillKopieraFlyttaEllerKlonaWidget(this.$root, this, eventData.fromWidgetId, eventData.toPageId, { typLaggTillKopieraFlyttaEllerKlona: 'kopiera' });
						break;
					}

				case 'flyttaWidgetTillSida':
					{
						// eventData = {
						//		widgetId,
						//		toPageId
						// }

						laggTillKopieraFlyttaEllerKlonaWidget(this.$root, this, eventData.widgetId, eventData.toPageId, { typLaggTillKopieraFlyttaEllerKlona: 'flytta' });
						break;
					}

				case 'andraWidget':
					{
						// Obs! Just detta even hanteras i förekommande fall internt av widget-komponenten. Här ska normalt inget göras.
						//console.log('andraWidget', eventId, eventData);
						//const widgetId = eventData;	// Enkom för tydlighet.
						break;
					}

				case 'taBortWidget':
					{
						//console.log('taBortWidget', eventId, eventData);

						const widgetId = eventData;	// Enkom för tydlighet.

						this.$root.AjaxpostaOchHanteraResultat('/widget/delete-widget', {
							formData: objectToFormData({ widgetId: widgetId }),
							//withoutSpinner: false,
							doljSpinnerOnSuccess: true,
							//onFailureFunction: undefined,
							//onCatchedErrorFunction: undefined,
							onSuccessFunction: (resultat) => {

								// Obs! Här laddar vi *inte* om sidan utan istället...
								// Ta bort widgeten från *skärmen*:
								this.taBortWidgetFranSkarmen(widgetId);
							},
						});

						break;
					}
			}
		},

		taBortWidgetFranSkarmen(widgetId)
		{
			// Ta bort från arrayen som är data som driver Vue:
			// Här muterar vi props!!!! Det är "ok"/funkar tack vare .sync på nivån över:
			// Todo: *Dock* är det fel sätt att göra detta på. Ett update-event ska egentligen istället skickas, men, som sagt, det funkar så här:

			let index = this.vpItems.map((item) => { return item.widgetId; }).indexOf(widgetId);
			this.vpItems.splice(index, 1);

			// Numrera om order för de som är kvar:
			let order = 1;	// Startvärde.
			this.vpItems.forEach(function(element) {
				element.order = order++;
			});

			// För att elementen ska hinna uppdateras av Vue:
			this.$nextTick(function () {
				// Sätt de (ev) uppdaterade dim och pos-värdena (höjden kan ha ändrats till följd av omdisponerade items):
				this.registreraPanelytansDimensionerOchPositioner();

				this.tweenanimeraPositionerEfterFlyttning();
			});
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		onItemDraggingStarted(payload) {
			//let ppcVue = payload.positioneradPanelcontainer;	// <positionerad-panelcontainer> – Vue-komponenten.
			//let ppcEl = ppcVue.$el;										// <positionerad-panelcontainer> – DOM element/node.
			//let he = payload.hammerEvent;

			//console.log(`\nonItemDraggingStarted: index: ${ppcVue.vpIndex}, order: ${ppcVue.vpOrder}, deltaX: ${he.deltaX}, deltaY: ${he.deltaY}`);

			//this.senasteMottagnaMuskoordinater = { x: he.center.x, y: he.center.y };

			// Ersatt med gemensam kod för både flytta och ändra storlek:
			//if (ppcVue.draggingIsMove)
			//{
			//	// Om pågående typ av dragning är "flytta"
			//	// Spara undan nuvarande order, för ev senare avbruten dragging:
			//	this.tidigareOrderUnderPagandeDragging = Array.from(this.vpItems, x => x.order);
			//}

			// Alt metod: Se "widgetDimensionsAndOrder.push({ ...".
			// Array.from kräver polyfill i IE11, vilket sköts via babel-grej i webpack.common.js.
			this.tidigareItemsDimOchPos = this.skapaArrayMedItemsDimOchPos();
		},


	//-------------------------------------------------------------------------------------------------------------------------------------

		onItemDragged(payload) {

			let ppcVue = payload.positioneradPanelcontainer;	// <positionerad-panelcontainer> – Vue-komponenten.
			let ppcEl = ppcVue.$el;										// <positionerad-panelcontainer> – DOM element/node.
			let he = payload.hammerEvent;
			//let arRepetition = payload.arRepetition;		// true = detta är en virtuell repetition initierad av denna metod själv (se nedan).

			let mouseX = he.center.x;
			let mouseY = he.center.y;

			//console.log(`\nonItemDragged${ arRepetition ? ' (repetition)' : '' }: index: ${ppcVue.vpIndex}, order: ${ppcVue.vpOrder}, deltaX: ${he.deltaX}, deltaY: ${he.deltaY}, muskoordinater x: ${mouseX}, y: ${mouseY}`, he);
			//console.log(`Additional event: ${he.additionalEvent}`);

			//if (!arRepetition)
			//{
			//	// Bara om det är ett äkta event som initierat anropet:
			//	this.senasteMottagnaMuskoordinater = { x: mouseX, y: mouseY };
			//}

			// Denna avser egentligen bara om ett bytt "äkta" panmove kommer, men skadar inte att köra alltid, även om det är en "repetition":
			this.stoppatimerForRepetitionAvInscrollningOmDenKor();




			let inscrollningY = 0;

			// På prov endast vid flyttning, *inte* vid sorleksändring:
			if (ppcVue.draggingIsMove)
			{
				// Fixa inscrollning om man är i kanten och det behövs:

				let rectPanelytan = this.$el.getBoundingClientRect();

				if (!this.isScrolledToTop
					&& he.additionalEvent == 'panup'
					&& this.coordinatesIntersectWithRect_TopEdge(mouseX, mouseY, rectPanelytan))
				{
					//console.log(`# Träff i ÖVRE kanten x: ${mouseX}, y: ${mouseY}, rectPanelytan: `, rectPanelytan);
					inscrollningY = -40;
				}
				else if (!this.isScrolledToBottom
					&& he.additionalEvent == 'pandown'
					&& this.coordinatesIntersectWithRect_BottomEdge(mouseX, mouseY, rectPanelytan))
				{
					//console.log(`# Träff i UNDRE kanten x: ${mouseX}, y: ${mouseY}, rectPanelytan: `, rectPanelytan);
					inscrollningY = 40;
				}
			}


			if (inscrollningY !== 0)
			{
				// Om inscrollning ska ske:

				this.$el.scrollBy(0, inscrollningY);

				// Schemalägg en eventuell repetition av denna eventhanterare (onItemDragged):

				// let that = this;
				// window.addEventListener('keydown', function(e) {return that.someMethod(e);});
				// window.addEventListener('keydown', (e) => {return that.someMethod(e);});
				// , () => { }

			//console.log(`Repetitionstimer kör redan: ${this.timerForRepetitionAvInscrollning !== null}`)

				if (this.timerForRepetitionAvInscrollning === null)
				{
					// Bara om en sådan här timer inte redan kör:

					this.count = this.count || 0;

					let that = this;
					//setTimeout((mouseX, mouseY, payload) => {
					this.timerForRepetitionAvInscrollning = setTimeout(() => {

							that.timerForRepetitionAvInscrollning = null;

							that.count++;
							//console.log(`TIMEOUT! Repetitionskontroll ${that.count} startar nu: Gamla x: ${mouseX}, y: ${mouseY} –>  x: ${that.senasteMottagnaMuskoordinater.x}, y: ${that.senasteMottagnaMuskoordinater.y}`);
						//console.log(`Repetitionstimer TIMEOUT! Repetition körs med payload:  center x,y: ${payload.hammerEvent.center.x}, ${payload.hammerEvent.center.y}  delta x,y: ${payload.hammerEvent.deltaX}, ${payload.hammerEvent.deltaY}`);

							//if (that.senasteMottagnaMuskoordinater.x === mouseX
							//	&& that.senasteMottagnaMuskoordinater.y === mouseY)
							//{
							////console.log(`ORÖRD! Repetition ${that.count} startar nu`);
							//	// Om man inte fått några senare muskoordinater från något musevent än de som man stod på när timers startades:
							//	// Pekaren står kvar på exakt samma "inscrollnings"-koordinater:

								// Repetera event-hanteraren onItemDragged, med exakt samma parametrar (utom flaggan payload.arRepetition) = ny inrullning (om inte färdigscrollat) + kontroll om item ska flyttas nu då:
								payload.arRepetition = true;
								that.onItemDragged(payload);
							//}
						}
						, 200		// Timeouttid i ms, för inscrollning
					);

				//console.log(`Ny repetitionstimer startad.  center x,y: ${payload.hammerEvent.center.x}, ${payload.hammerEvent.center.y}  delta x,y: ${payload.hammerEvent.deltaX}, ${payload.hammerEvent.deltaY}`);
				}

				// Schedule the function to run at the start of the frame:
				let that = this;
				window.requestAnimationFrame(function () {
					// Sätt de (ev) uppdaterade dim och pos-värdena:
					that.registreraPanelytansDimensionerOchPositioner();
				});

			}
			else
			{
				// Annars, om det *inte* är inscrollning:

				let currentIndex = ppcVue.vpIndex;

				if (ppcVue.draggingIsMove)
				{
					// Om pågående typ av dragning är "flytta"

					////console.log(`Tween pågår redan vid onItemDragged? isActive = ${this.tween.timeline.isActive()}}`);
					//if (this.tween.timeline.isActive()
					//	|| inscrollningY !== 0)
					//{
					//	// Om en tween-animering pågår
					//	// ELLER en inscrollning gjorts ovan:

					//	//// Kolla *inte* om flyttning ska ske (inte heller inscrollning, repetition m.m.):
					//	//console.log('Tween pågår redan. Flyttkontroll m.m. hoppas helt över.');

					//	//this.tween.timeline
					//	//	.totalProgress(1, true)		// Force to completion. 1 = 100% och true = suppressEvents
					//	//	.clear();						// Empties the timeline of all tweens, timelines, callbacks and labels.
					//	//console.log(`Tween pågår redan vid onItemDragged. FORCE TO COMPLETION + CLEAR! Därefter är isActive = ${this.tween.timeline.isActive()}}`);
					//}
					//else
					//{

					// Annars: Kolla om flyttning ska ske:

					// Gå igenom alla items på panelytan och kolla om prel flyttning ska ske "dit":

					let currentOrder = ppcVue.vpOrder;

					let nyOrder = null;	// Null = nej, ingen ny...
					let changeOrderValue = null;
					let changeOrderStartAtOldOrder = null;
					let changeOrderEndAtOldOrder = null;

					let antalItems = this.vpItems.length;

					let checkedIndex = antalItems;
					while (--checkedIndex >= 0)
					{

						if (checkedIndex != currentIndex)
						{
							// Inte kolla sig själv  ;)

							let checkedPpcVue = this.$children[checkedIndex];	// Vue componenten
							let checkedPpcEl = checkedPpcVue.$el;		// DOM-elementet

							if (checkedPpcEl._gsTransform.x === 0
								&& checkedPpcEl._gsTransform.y === 0)
							{
								// Bara om det elementet inte håller på att tweena (annars hoppas det bara över):

								let rectCheckedPpcEl = checkedPpcEl.getBoundingClientRect();
								// Detta fixas nu med import GetBoundingClientRectFixIE:
								//// Obs! I IE 11/Edge 17: The returned object lacks x & y values, though existing top & left values can be used instead.
								//// Så för konsistens sätter vi alltid x, y = left, top här:
								//rectCheckedPpcEl.x = rectCheckedPpcEl.left;
								//rectCheckedPpcEl.y = rectCheckedPpcEl.top;

								let checkedOrder = this.vpItems[checkedIndex].order;	//checkedPpcVue.vpOrder;

								let checkedIsLastOnLine = (checkedOrder === antalItems);		// Initialt (!), sist på sista raden?

								if (!checkedIsLastOnLine)
								{
									// Om det inte redan är bestämt att det är sist på sista raden:
									// Kolla om det är sist på någon tidigare rad:

									// Leta upp det el som ligger efter det kontrollerade i order:
									let i = antalItems;
									let found = false;
									while (--i >= 0 && !found)
									{
										if (this.vpItems[i].order === checkedOrder + 1)
										{
											// Om det ligger efter det kontrollerade:
											found = true;

											// Kolla om det ligger först på en rad:
											if (this.$children[i].$el.offsetLeft === 0)
											{
												checkedIsLastOnLine = true;
											}
										}
									}
								}

								if (coordinatesIntersectWithRect_LeftHalf(mouseX, mouseY, rectCheckedPpcEl))
								{
									//console.log(`# Index ${currentIndex}, plats ${currentOrder} är över VÄNSTRA delen av index ${checkedIndex} med plats ${checkedOrder}.`);

									// Muspekaren står över den kontrollerade ppc's *vänstra* halva:
									// Det släpade ppc ska placeras *före* det kontrollerade ppc:
									if (currentOrder !== checkedOrder - 1)
									{
										// ...men *bara* om det inte redan har den positionen:

										if (checkedOrder > currentOrder)
										{
											// Flyttat item ska flyttas till *senare* plats:

											// Ny plats, *efter* omflyttningarna enl nedan:
											nyOrder = checkedOrder - 1;

											// Då ska de här andra ska flyttas så här, till *tidigare* plats (*före* order sätts om på det flyttade!):
											changeOrderValue = -1;
											changeOrderStartAtOldOrder = currentOrder + 1;	// Flytta de med plats från denna...
											changeOrderEndAtOldOrder = nyOrder;						// ...till denna.

										}
										else
										{
											// Annars, flyttat item ska flyttas till *tidigare* plats:

											// Ny plats, *efter* omflyttningarna enl nedan:
											nyOrder = checkedOrder;

											// Då ska de här andra ska flyttas så här, till *senare* plats (*före* order sätts om på det flyttade!):
											changeOrderValue = 1;
											changeOrderStartAtOldOrder = nyOrder;				// Flytta de med plats från denna...
											changeOrderEndAtOldOrder = currentOrder - 1;	// ...till denna.
										}

										checkedIndex = -1; // Hoppa ur while-loopen vid nästa check!
									}
								}
								else if (coordinatesIntersectWithRect_RightHalf(mouseX, mouseY, rectCheckedPpcEl, checkedIsLastOnLine))	// Sista arg är true om det är det sista item på en rad.
								{
									//console.log(`# Index ${currentIndex}, plats ${currentOrder} är över HÖGRA delen av index ${checkedIndex} med plats ${checkedOrder}.`);

									// Muspekaren står över den kontrollerade ppc's *vänstra* halva:
									// Det släpade ppc ska placeras *efter* det kontrollerade ppc:
									if (currentOrder !== checkedOrder + 1)
									{
										// ...men *bara* om det inte redan har den positionen:

										if (checkedOrder > currentOrder)
										{
											// Flyttat item ska flyttas till *senare* plats:

											// Ny plats, *efter* omflyttningarna enl nedan:
											nyOrder = checkedOrder;

											// Då ska de här andra ska flyttas så här, till *tidigare* plats (*före* order sätts om på det flyttade!):
											changeOrderValue = -1;
											changeOrderStartAtOldOrder = currentOrder + 1;	// Flytta de med plats från denna...
											changeOrderEndAtOldOrder = nyOrder;						// ...till denna.

										}
										else
										{
											// Annars, flyttat item ska flyttas till *tidigare* plats:

											// Ny plats, *efter* omflyttningarna enl nedan:
											nyOrder = checkedOrder + 1;

											// Då ska de här andra ska flyttas så här, till *senare* plats (*före* order sätts om på det flyttade!):
											changeOrderValue = 1;
											changeOrderStartAtOldOrder = nyOrder;				// Flytta de med plats från denna...
											changeOrderEndAtOldOrder = currentOrder - 1;	// ...till denna.
										}

										checkedIndex = -1; // Hoppa ur while-loopen vid nästa check!
									}
								}
							}
						}

					}	// while



					//-------------------------------------------------------------------------------------------------------------------------------------

					if (nyOrder !== null)
					{
						// Om item ska flyttas:

						// Obs! För att Tween-animeringen ska få rätt värden, innan Vue-reactiviteten slagit in, sätts order-värdena *även* direkt på elementen i DOM här:
						// Backat vad som följer på denna rad, för det funkade dållit: Testar annat alt: this.$nextTick( .. ) nedan ist.

						//console.log(`# Flytta plats ${ppcVue.vpOrder} till ${nyOrder} (och ${changeOrderStartAtOldOrder}–${changeOrderEndAtOldOrder} ett steg åt ${(changeOrderValue == 1 ? '–>' : '<–')}).`);

						// Ändra *först* plats på en del övriga items:
						let i = antalItems;
						while (--i >= 0)
						{
							let oldOrder = this.vpItems[i].order;

							if (oldOrder >= changeOrderStartAtOldOrder
								&& oldOrder <= changeOrderEndAtOldOrder)
							{
								// Här muterar vi props!!!! Det är "ok"/funkar tack vare .sync på nivån över:
								// Todo: *Dock* är det fel sätt att göra detta på. Ett update-event ska egentligen istället skickas, men, som sagt, det funkar så här:
								this.vpItems[i].order += changeOrderValue;

								// Obs! För att Tween-animeringen ska få rätt värden, innan Vue-reactiviteten slagit in, sätts order-värdena *även* direkt på elementen i DOM här:
								// Backat vad som följer på denna rad, för det funkade dållit: Testar annat alt: this.$nextTick( .. ) nedan ist.
								let ppcEl = this.$children[i].$el;			// <positionerad-panelcontainer> – DOM element/node.
								ppcEl.style.order = this.vpItems[i].order;
							}
						}

						// *Därefter* byter vi plats på det flyttade:
						// Här muterar vi props!!!! Det är "ok"/funkar tack vare .sync på nivån över:
						// Todo: *Dock* är det fel sätt att göra detta på. Ett update-event ska egentligen istället skickas, men, som sagt, det funkar så här:
						this.vpItems[currentIndex].order = nyOrder;

						// Obs! För att Tween-animeringen ska få rätt värden, innan Vue-reactiviteten slagit in, sätts order-värdena *även* direkt på elementen i DOM här:
						// Backat vad som följer på denna rad, för det funkade dållit: Testar annat alt: this.$nextTick( .. ) nedan ist.
						let ppcEl = this.$children[currentIndex].$el;			// <positionerad-panelcontainer> – DOM element/node.
						ppcEl.style.order = nyOrder;


						// Schedule the function to run at the start of the frame:
						let that = this;
						window.requestAnimationFrame(function () {

							// Funkar nu, när jag kastat ut timeline :)
							////// Obs! Lyckades inte få till beteendet i exemplet på https://codepen.io/osublake/pen/QjQGBa, där en ny layout/tween liksom hakar på den förra, pågående där den är och tweenar därifrån! Jag gissar att det är koden vid kommentaren "Reversed delta values taking into account currenttransforms in case animation was interrupted" som var avsedd för detta, men det funkar inte hos mig. Fattar inte varför och avbryter klurandet for now! Kanske beror på att jag använder timeline?? YES, det var det. Plockat bort timeline igen, av den orsaken.

							//if (arRepetition)
							//{
							//	// Om det är en repetition (inget äkta event) pga inscrollning:
							//	// Skippa tween för att få inscrollningen att upplevas mjukare:

							//	// Backat på detta tick, se kommentarer med "Backat vad som följer på denna rad.." ovan:
							//	//this.$nextTick(function () {
							//		// Nu är ändringarna ovan genomförda i DOM:
							//	//});

							//	// Sätt de (ev) uppdaterade dim och pos-värdena:
							//	that.registreraPanelytansDimensionerOchPositioner();
							//}
							//else
							//{
							//	// Backat på detta utkommenterade tick, se kommentarer med "Backat vad som följer på denna rad.." ovan:
							//	////this.$nextTick(function () {
							//	//// Flyttad in i tweenanimeraPositionerEfterFlyttning():
							//	////this.$nextTick(function () {
							//	////	// Nu är ändringarna ovan genomförda i DOM:
							//	////	// Layouta om, med Tween-animering vid behov:
							//	////	this.tweenanimeraPositionerEfterFlyttning(this);
							//	////})

								//if (this.tween.timeline.isActive())
								//{
								//	// Om en tidigare tween-animering fortfarande pågår:
								//	this.tween.timeline
								//		.totalProgress(1, true)		// Force to completion. 1 = 100% och true = suppressEvents
								//		.clear();						// Empties the timeline of all tweens, timelines, callbacks and labels.
								////console.log(`Tween pågår redan vid onItemDragged. FORCE TO COMPLETION + CLEAR! Därefter är isActive = ${this.tween.timeline.isActive()}}`);
								//}


								// Sätt de (ev) uppdaterade dim och pos-värdena (höjden kan ha ändrats till följd av omdisponerade items):
								that.registreraPanelytansDimensionerOchPositioner();

								if (inscrollningY === 0)
								{
									// Bara om det inte är i samband med att en inscrollning också gjorts (annars sker omdisponeringen helt utan animation):
									that.tweenanimeraPositionerEfterFlyttning();
								}

							//}
						});
					}

					//}
				}
				else
				{
					// Annars är pågående typ av dragning "ändra storlek":

					// Här muterar vi props!!!! Det är "ok"/funkar tack vare .sync på nivån över:
					// Todo: *Dock* är det fel sätt att göra detta på. Ett update-event ska egentligen istället skickas, men, som sagt, det funkar så här:
					this.vpItems[currentIndex].widthInGridUnits = ppcEl.style.width.replace('px', '') / this.vpGrid.x;
					this.vpItems[currentIndex].heightInGridUnits = ppcEl.style.height.replace('px', '') / this.vpGrid.y;

				//console.log(`onItemDragged – ändra storlek till ${this.vpItems[currentIndex].widthInGridUnits}, ${this.vpItems[currentIndex].heightInGridUnits}`);

					// Obs! För att Tween-animeringen ska få rätt värden, innan Vue-reactiviteten slagit in, sätts w/h-värdena *även* direkt på elementen i DOM:
					// I detta fall (ändra storlek, till skillnad från flytta) görs detta direkt i underkomponenten <positionerad-panelcontainer>. Det är alltså klart vid detta laget.


					// Schedule the function to run at the start of the frame:
					let that = this;
					window.requestAnimationFrame(function () {

						// Sätt de (ev) uppdaterade dim och pos-värdena (höjden kan ha ändrats till följd av omdisponerade items):
						that.registreraPanelytansDimensionerOchPositioner();

						if (inscrollningY === 0)
						{
							// Bara om det inte är i samband med att en inscrollning också gjorts (annars sker omdisponeringen helt utan animation):
							that.tweenanimeraPositionerEfterFlyttning();
						}

					});
				}

			}
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		onItemDraggingCanceled(payload) {
			//let ppcVue = payload.positioneradPanelcontainer;	// <positionerad-panelcontainer> – Vue-komponenten.
			//let ppcEl = ppcVue.$el;										// <positionerad-panelcontainer> – DOM element/node.
			//let he = payload.hammerEvent;

			//console.log(`\nonItemDraggingCanceled: index: ${ppcVue.vpIndex}, order: ${ppcVue.vpOrder}`);

			this.stoppatimerForRepetitionAvInscrollningOmDenKor();

			// Ersatt med gemensam kod för både flytta och ändra storlek:
			//if (ppcVue.draggingIsMove)
			//{
			//	// Om pågående typ av dragning är "flytta"
			//	// (Då storleksändring avbryts sker detta istället en nivå ner, i euiPositioneradPanelcontainer.js.)

			//	// Återställ tidigare order:
			//	let i = this.vpItems.length;
			//	while (--i >= 0)
			//	{
			//		this.vpItems[i].order = this.tidigareOrderUnderPagandeDragging[i];
			//	}

			//	// Resetta:
			//	this.tidigareOrderUnderPagandeDragging.length = 0;
			//}


			// Både vid flyttning och storleksändring:

			// Återställ tidigare order och w/h:
			let i = this.vpItems.length;
			while (--i >= 0)
			{
				this.vpItems[i].order = this.tidigareItemsDimOchPos[i].order;
				this.vpItems[i].widthInGridUnits = this.tidigareItemsDimOchPos[i].widthInGridUnits;
				this.vpItems[i].heightInGridUnits = this.tidigareItemsDimOchPos[i].heightInGridUnits;
			}

			// Resetta:
			this.tidigareItemsDimOchPos.length = 0;



			// Avbrytandet kan ha ändrat (tillbaka) dispositionen av items:

			// Schedule the function to run at the start of the frame:
			let that = this;
			window.requestAnimationFrame(function () {

				// Todo: Har sättningen av Vue props ovan garanterat hunnit slå igenom till DOM här?? Eller behövs en nextTick? Eller kanske ännu senare????

				// Sätt de (ev) uppdaterade dim och pos-värdena (höjden kan ha ändrats till följd av omdisponerade items):
				that.registreraPanelytansDimensionerOchPositioner();

				that.tweenanimeraPositionerEfterFlyttning();
			});
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		onItemDropped(payload) {
			//let ppcVue = payload.positioneradPanelcontainer;	// <positionerad-panelcontainer> – Vue-komponenten.
			//let ppcEl = ppcVue.$el;										// <positionerad-panelcontainer> – DOM element/node.
			//let he = payload.hammerEvent;
			//console.log(`\nonItemDropped: index: ${ppcVue.vpIndex}, order: ${ppcVue.vpOrder}, deltaX: ${he.deltaX}, deltaY: ${he.deltaY}`);

			// Här behöver vi inte göra något särskilt. Draggningen har redan avbrutits av euiPositioneradPanelcontainer och item är placerad och klar där den ska vara :)

			this.stoppatimerForRepetitionAvInscrollningOmDenKor();

			// Resetta:
			this.tidigareItemsDimOchPos.length = 0;

			// Spara nya ordningen och storlekar i db:

			// Skapa en array med värden att POSTa:
			let dimOchPos = this.skapaArrayMedItemsDimOchPos();

			this.$root.AjaxpostaOchHanteraResultat('/widget/update-widget-dimensions-and-order', {
				formData: objectToFormData({ dataJson: JSON.stringify(dimOchPos) }),
				withoutSpinner: true,
				//doljSpinnerOnSuccess: false,
				//onFailureFunction: undefined,
				//onCatchedErrorFunction: undefined,
				//onSuccessFunction: undefined,
			});
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		// Inte längre pancancel. Den skickas i tid och otid och det är för mig oklart vad exakt den innebär!
		//onItemDraggingCanceled(payload) {
		////console.log(`\nonItemDraggingCanceled: index: ${payload.index}, deltaX: ${payload.e.deltaX}, deltaY: ${payload.e.deltaY}`);


		//-------------------------------------------------------------------------------------------------------------------------------------

		stoppatimerForRepetitionAvInscrollningOmDenKor() {

			if (this.timerForRepetitionAvInscrollning !== null)
			{
				clearTimeout(this.timerForRepetitionAvInscrollning);
				this.timerForRepetitionAvInscrollning = null;

			//console.log('Repetitionstimer STOPPAD');
			}
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		registreraPanelytansDimensionerOchPositioner() {	//vueComp) {

			let el = this.$el;

			let oldAsJson = JSON.stringify(this.panelytansDimensionerOchPositioner);

			// Se bilden '\_dokumentation\Dimensionering och positionering av element (offset, client, scroll, margin, border, padding etc) 2.png' för lite guidance:

			// Offset:
			this.panelytansDimensionerOchPositioner.offset = {
				left: el.offsetLeft,
				top: el.offsetTop,
				width: el.offsetWidth,
				height: el.offsetHeight
			};

			// Client:
			this.panelytansDimensionerOchPositioner.client = {
				left: el.clientLeft,
				top: el.clientTop,
				width: el.clientWidth,
				height: el.clientHeight
			};

			// Scroll:
			this.panelytansDimensionerOchPositioner.scroll = {
				left: el.scrollLeft,
				top: el.scrollTop,
				width: el.scrollWidth,
				height: el.scrollHeight
			};

			let andrade = (oldAsJson !== JSON.stringify(this.panelytansDimensionerOchPositioner));

			//console.log(`Registrerat nya dim/pos för panelen: ändrade: ${andrade}.`, oldAsJson, this.panelytansDimensionerOchPositioner);

			return andrade;
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		tweenanimeraPositionerEfterFlyttning() {

			//console.log('tweenanimeraPositionerEfterFlyttning anropad');

			// Backat på detta tick, se kommentarer med "Backat vad som följer på denna rad.." ovan:
			//// Invänta att DOM-förändringar (bl.a. Vue-reaktiva) är klara:
			//this.$nextTick(function () {
			//	// Nu är ändringarna genomförda i DOM:

				//// Sätt de (ev) uppdaterade dim och pos-värdena:
				//this.registreraPanelytansDimensionerOchPositioner();

				// Denna behövs inte längre? Har bytt ut event-lyssnaren mot en watch:
				//// För event-lyssningens throttlande:
				//that.tween.dirty = false;

				//console.log(`Tween pågår redan vid tweenanimeraPositionerEfterFlyttning? isActive = ${this.tween.timeline.isActive()}}`);
				//if (this.tween.timeline.isActive())
				//{
				//	// Om en annan tween-animering redan pågår:
				//	this.tween.timeline
				//		.totalProgress(1, true)		// Force to completion. 1 = 100% och true = suppressEvents
				//		.clear();						// Empties the timeline of all tweens, timelines, callbacks and labels.
				//
				////console.log(`Tween pågår redan vid tweenanimeraPositionerEfterFlyttning. FORCE TO COMPLETION + CLEAR! Därefter är isActive = ${this.tween.timeline.isActive()}}`);
				//}

				//if (!this.tween.timeline.isActive())
				//{
				//	// Bara om en tween-animering *inte* redan pågår:

			//--------------------------------------------------------

			//let forraTweenStoppad = false;

			//console.log('\nSkapa Tween:');


			for (let i = 0; i < this.tween.antalNodes; i++) {

				let tweenInfo = this.tween.tweenInfos[i];

				// Get last offset position:
				let lastX = tweenInfo.x;
				let lastY = tweenInfo.y;

				// Record new offset position:
				tweenInfo.x = tweenInfo.node.offsetLeft;
				tweenInfo.y = tweenInfo.node.offsetTop;

				////console.log(`== Tweenkoll av [${i}] – Gamla x,y: ${lastX}, ${lastY} –> ${tweenInfo.x}, ${tweenInfo.y}. ${(lastX !== tweenInfo.x || lastY !== tweenInfo.y ? 'FLYTTAD!' : '')}`, this.tween.timeline.getChildren());
				//console.log(`== Tweenkoll av [${i}] – Gamla x,y: ${lastX}, ${lastY} –> ${tweenInfo.x}, ${tweenInfo.y}. ${(lastX !== tweenInfo.x || lastY !== tweenInfo.y ? 'FLYTTAD!' : '')}`);

				//if (!this.tween.timeline.isActive())
				//{
				//	// Bara om en tween-animering *inte* redan pågår:

					if (lastX !== tweenInfo.x || lastY !== tweenInfo.y)
					{
						// If node has moved:

						// Todo: Fick inte att funka så här. Ger upp for now:
						// Istället hoppas ny tween över om en tidigare redan pågår (ovan). Det kind of förutsätter att anv inte kan trigga/triggar layoutförändringar i snabb takt samt att tween-duration är kort.
						//if (!forraTweenStoppad && this.tween.timeline.isActive())
						//{
						//	// Om en pågående, tidigare tween-animering inte redan stoppats och den pågår nu, när första nya tween-behovet hittats:
						//	// "Stoppa" alla pågående/kommande tweens där de är (hänsyn till detta i nya tweenen tas nedan ("reversed delta"):
						//	this.tween.timeline
						//		//.totalProgress(1, true)		// Force to completion. 1 = 100% och true = suppressEvents
						//		.clear();						// Empties the timeline of all tweens, timelines, callbacks and labels.
						//	forraTweenStoppad = true;
						//}

						// Reversed delta values taking into account currenttransforms in case animation was interrupted:
						let x = tweenInfo.transform.x + lastX - tweenInfo.x;
						let y = tweenInfo.transform.y + lastY - tweenInfo.y;

						// Sätts initialt ist:
						// this.tween.duration = event && event.type === 'resize' ? 0 : 0.5;

						////console.log(`==== Tween to 0,0 [${i}] – Från x,y: ${x}, ${y} –> 0,0`, this.tween.timeline.getChildren());
						//console.log(`==== Tween to 0,0 [${i}] – Från x,y: ${x}, ${y} –> 0,0`);

						// Tween to 0,0 to remove the transforms
						// Args: target:Object, duration:Number, fromVars:Object, toVars:Object, position:*
						TweenLite.fromTo(

						// Add to timeline ist:
						// Adds a TweenLite.fromTo() tween to the end of the timeline - this is a convenience method that accomplishes exactly the same thing as add( TweenLite.fromTo(...) ) but with less code.
						//this.tween.timeline.fromTo(

							tweenInfo.node,
							this.tween.duration,
							{ x: x, y: y },
							{ x: 0, y: 0, ease: Power1.easeInOut },
							//{ x: 0, y: 0, ease: Elastic.easeOut.config(1, 0.5) },
							// To have tweens run in parallel you need to insert them at the same point in time in the timeline:
							0
						);
					}
				//}
			}

			//this.tween.timeline.pause();
			//console.log(this.tween.timeline.getChildren());
			//console.log(`Tween pågår vid tweenanimeraPositionerEfterFlyttning NU då? isActive = ${this.tween.timeline.isActive()}}`);
				//}
			//});
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		// Behövs inte f.n:
		//coordinatesIntersectWithRect_LeftEdge(x, y, rect) {

		//	let edgeRect = new DOMRect(
		//		rect.x,
		//		rect.y,
		//		(this.vpGap/2 + this.edgeOverlappingSize),	// Bara kanten!
		//		rect.height);

		//	return coordinatesIntersectWithRect(x, y, edgeRect);
		//},


		//-------------------------------------------------------------------------------------------------------------------------------------

		// Behövs inte f.n:
		//coordinatesIntersectWithRect_RightEdge(x, y, rect) {
		//
		//	let edgeRect = new DOMRect(
		//		rect.x + rect.width - (this.vpGap/2 + this.edgeOverlappingSize),	// Bara kanten!
		//		rect.y,
		//		(this.vpGap/2 + this.edgeOverlappingSize),	// Bara kanten!
		//		rect.height);
		//
		//	return coordinatesIntersectWithRect(x, y, edgeRect);
		//},



		//-------------------------------------------------------------------------------------------------------------------------------------

		coordinatesIntersectWithRect_TopEdge(x, y, rect) {

			let edgeRect = new DOMRect(
				rect.x,
				rect.y - 100,	// Även 100 utanför kanten. Detta funkar i alla fall bra när denna metod används vid drag-and-drop.
				rect.width,
				(this.vpGap/2 + this.edgeOverlappingSize) + 100,	// Bara kanten! Även 100 utanför kanten. Detta funkar i alla fall bra när denna metod används vid drag-and-drop.
			);

			//console.log(`# Kollar ÖVRE kanten x: ${x}, y: ${y}, rect: `, edgeRect);

			return coordinatesIntersectWithRect(x, y, edgeRect);
		},


		//-------------------------------------------------------------------------------------------------------------------------------------

		coordinatesIntersectWithRect_BottomEdge(x, y, rect) {

			let edgeRect = new DOMRect(
				rect.x,
				rect.y + rect.height - (this.vpGap/2 + this.edgeOverlappingSize),	// Bara kanten!
				rect.width,
				(this.vpGap/2 + this.edgeOverlappingSize) + 100,	// Bara kanten! Även 100 utanför kanten. Detta funkar i alla fall bra när denna metod används vid drag-and-drop.
			);

			return coordinatesIntersectWithRect(x, y, edgeRect);
		},

	},


	//-------------------------------------------------------------------------------------------------------------------------------------

	//created() {
	//	// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
	//	// Exempel: this.$_undertryckNastaAndradEvent = false;
	//},


	//-------------------------------------------------------------------------------------------------------------------------------------

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------

		//## 2. Appens/komponentens mounted hook:  #################################
		//console.log('2. Appens/komponentens mounted hook');

		// Kolla att vpGap är ett jämnt tal:
		if (this.vpGap / 2 !== Math.trunc(this.vpGap / 2))
			console.error(`Det värde du angett för attributet 'vp-gap' (${this.vpGap}) måste vara ett jämnt tal. Ändra!`);

		// Här, bl.a. för att slippa sätta dem i html-markupen. Det är en helt intern, dold hantering:
		this.$on('itemDraggingStarted', this.onItemDraggingStarted);
		this.$on('itemDragged', this.onItemDragged);
		this.$on('itemDraggingCanceled', this.onItemDraggingCanceled);
		this.$on('itemDropped', this.onItemDropped);


		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('4. Appens/komponentens mounted hook + nextTick');


			//---------------------------------------------------------------------------------------------------------------

			Vue.nextTick(function () {

					//## 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated):  #################################
					//console.log('6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated)');


					//---------------------------------------------------------------------------------------------------------------

					//this.computedStyle = window.getComputedStyle(this.$el);

					// Sätt de initiala dim och pos-värdena:
					this.registreraPanelytansDimensionerOchPositioner();

					// Bevaka scroll-events och sätt vid behov om scrollposition (och övriga dim och pos också fast det inte borde behövas):
					this.$el.addEventListener('scroll',
						throttla(() => this.registreraPanelytansDimensionerOchPositioner(),
							100,	// Så lång throttlingstid i ms.
							{ trailing: true, leading: false }	// Setting the leading to true will begin callback execution immediately and then throttle. When you set *both* leading and trailing to true, this guarantees execution per interval.
						),
						false
					);


					//---------------------------------------------------------------------------------------------------------------

					// Set up för Tween-animations:
					//
					// Efter exempelkod på:
					// https://codepen.io/osublake/pen/zwWgao
					// ..beskrivet i https://greensock.com/forums/topic/16839-how-to-manipulate-flex-values/?do=findComment&comment=74728
					// "'Relative animations': To do a flexbox animations, start off by recording the position of your element in it's current state. Now change its flexbox style and let the browser reposition it. Now record the new position of your element. You now know where the element was, and where its supposed to be. Now move your element back to it's old position and animate it to it's new position. This all takes place in between animation frames, so you won't see the jump."
					// ..m.fl från samma författare, ex.vis:
					// https://greensock.com/forums/topic/15243-smoothing-out-flexbox/?do=findComment&comment=66155
					//
					// Info om Greensock (GSAP)/TweenLite: https://greensock.com/docs/TweenLite

					// Dok: https://greensock.com/docs/TimelineLite/TimelineLite()
					//this.tween.timeline = new TimelineLite({
					//	delay: 0,						// Amount of delay in seconds (or frames for frames-based tweens) before the animation should begin.
					//	paused: false,					// If true, the animation will pause itself immediately upon creation.
					//	immediateRender: true,		// vänta inte på nästa frame/tick.
					//	smoothChildTiming: true,	//Controls whether or not child tweens/timelines are repositioned automatically (changing their startTime) in order to maintain smooth playback when properties are changed on-the-fly.
					//	autoRemoveChildren: true,	// If autoRemoveChildren is set to true, as soon as child tweens/timelines complete, they will automatically get killed/removed. This is normally undesireable because it prevents going backwards in time (like if you want to reverse() or set the progress lower, etc.). It can, however, improve speed and memory management. The root timelines use autoRemoveChildren:true.

					//	//onComplete: Function  - A function that should be called when the animation has completed.
					//	//onCompleteScope: Object  - Defines the scope of the onComplete function (what "this" refers to inside that function).
					//	//onStart: Function  - A function that should be called when the animation begins (when its time changes from 0 to some other value which can happen more than once if the tween is restarted multiple times).
					//	//onStartScope: Object - Defines the scope of the onStart function (what "this" refers to inside that function).
					//	//onCompleteParams:  Array - An Array of parameters to pass the onComplete function.
					//	//onStartParams:  Array - An Array of parameters to pass the onStart function.
					//	//onUpdateParams:  Array - An Array of parameters to pass the onUpdate function.
					//	//onReverseCompleteParams:  Array - An Array of parameters to pass the onReverseComplete function.
					//	//callbackScope:  Object - The scope to be used for all of the callbacks (onStart, onUpdate, onComplete, etc.).

					//	//onComplete: tl.gotoAndPlay,
					//	//onCompleteScope: tl,
					//	//onCompleteParams: ["spin"],
					//}),

					this.tween.antalNodes = this.$children.length;
					this.tween.nodes = new Array(this.tween.antalNodes);
					//this.tween.dirty = false;	// Annars blir det dubbla anrop initialt väl, då vi anropar manuellt nedan. // true;
					this.tween.duration = .3;
					this.tween.tweenInfos = new Array(this.tween.antalNodes);	//[];

					for (let i = 0; i < this.tween.antalNodes; i++) {

						this.tween.nodes[i] = this.$children[i].$el;			// <positionerad-panelcontainer> – DOM element/node.
						let node = this.tween.nodes[i];

						// Initialize transforms on node
						TweenLite.set(node, { x: '+=0' });

						let transform = node._gsTransform;
						let x = node.offsetLeft;
						let y = node.offsetTop;

						this.tween.tweenInfos[i] = { node, transform, x, y };
					}

					//console.log(`Förberett Tween för ${this.tween.antalNodes} st element.`, this.tween.nodes, this.tween.tweenInfos);

					// Görs nu på annat sätt, med vueResponsiveComponentsMixin:
					//// Lyssna efter fönsterskalning (som kan rendera i omflödning av items):
					//let that = this;
					//window.addEventListener('resize', () => { that.tween.dirty = true; });
					//TweenLite.ticker.addEventListener('tick', () => that.tween.dirty && that.tweenanimeraPositionerEfterFlyttning(that));

					// Kör första layoutandet (initiera):
					// Bör inte behövas: this.tweenanimeraPositionerEfterFlyttning();

				}
				, this	// Vue.nextTick 'this' context.
			);

		});
	},
};
